import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";

const SelectcustomStyles = {
  control: (base) => ({ ...base, minHeight: 33.1, height: 33.1 }),
  dropdownIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  clearIndicator: (base) => ({ ...base, padding: "2px 8px" }),
  valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
};


const categoryOptions = [
  { label: "Staff", value: "Staff" },
  { label: "Manager", value: "Manager" },
  { label: "Admin", value: "Admin" },
];

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "PACKING", value: "PACKING" },
  { label: "CUTTING", value: "CUTTING" },
];

const designationOptions = [
  { label: "Office Assistant", value: "Office Assistant" },
  { label: "Apprentice", value: "Apprentice" },
  { label: "Senior Manager", value: "Senior Manager" },
];

const PayrollReportMonthlyProfTax = () => {
  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      employeeCode: "",
      employeeName: "",
      fromMonth: "",
      toMonth: "",
    },
    validationSchema: Yup.object({
      fromMonth: Yup.string().required("From Month is required"),
      toMonth: Yup.string().required("To Month is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Submitted", values);
    },
  });

  const data = [
    { sno: 1, code: "001", name: "ARUN", doj: "01.01.24", category: "Staff", department: "QUALITY CONTROL", designation: "Office Assistant", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 856, mar25Earnings: 17000, total: 856 },
    { sno: 2, code: "002", name: "VIGNESH", doj: "01.01.24", category: "Staff", department: "PRODUCTION", designation: "Apprentice", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 40100, total: 1250 },
    { sno: 3, code: "003", name: "ULAGURAJ", doj: "01.01.24", category: "Manager", department: "PACKING", designation: "Senior manager", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 20000, total: 1250 },
    { sno: 4, code: "005", name: "PARAMESH", doj: "01.01.24", category: "Staff", department: "CUTTING", designation: "Assistant Engineer", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 41000, total: 1250 },
    { sno: 5, code: "006", name: "REVATHY", doj: "01.02.24", category: "Staff", department: "Admin", designation: "Cash officer", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 22000, total: 1250 },
    { sno: 6, code: "007", name: "REKHA", doj: "12.12.23", category: "Admin", department: "CUTTING", designation: "Assistant Engineer", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 40000, total: 1250 },
    { sno: 7, code: "008", name: "MALLIKA", doj: "13.07.23", category: "Admin", department: "ANCILLARY", designation: "Apprentice", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 52000, total: 1250 },
    { sno: 8, code: "009", name: "MAHALINGAM", doj: "06.02.24", category: "Staff", department: "PRODUCTION", designation: "Junior Engineer", jan25: 0, jan25Earnings: 0, feb25: 0, feb25Earnings: 0, mar25: 1250, mar25Earnings: 22000, total: 1250 },
  ];

  const columns = [
    { Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "Code", accessor: "code" },
    { Header: "Name", accessor: "name" },
    { Header: "DOJ", accessor: "doj" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "JAN-25", accessor: "jan25", sum: true },
    { Header: "JAN-25 Earnings", accessor: "jan25Earnings", sum: true },
    { Header: "FEB-25", accessor: "feb25", sum: true },
    { Header: "FEB-25 Earnings", accessor: "feb25Earnings", sum: true },
    { Header: "MAR-25", accessor: "mar25", sum: true },
    { Header: "MAR-25 Earnings", accessor: "mar25Earnings", sum: true },
    { Header: "Total", accessor: "total", sum: true },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Payroll" breadcrumbItem="Monthly ProfTax Register" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Category</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="category"
                    options={categoryOptions}
                    value={categoryOptions.find(opt => opt.value === formik.values.category) || null}
                    onChange={(opt) => formik.setFieldValue("category", opt?.value || "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Department</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="department"
                    options={departmentOptions}
                    value={departmentOptions.find(opt => opt.value === formik.values.department) || null}
                    onChange={(opt) => formik.setFieldValue("department", opt?.value || "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Designation</Label>
                  <Select
                    styles={SelectcustomStyles}
                    name="designation"
                    options={designationOptions}
                    value={designationOptions.find(opt => opt.value === formik.values.designation) || null}
                    onChange={(opt) => formik.setFieldValue("designation", opt?.value || "")}
                    placeholder="--Select--"
                  />
                </Col>
                <Col md={4}>
                  <Label>Employee Code</Label>
                  <Input
                    type="text"
                    name="employeeCode"
                    value={formik.values.employeeCode}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col md={4}>
                  <Label>Employee Name</Label>
                  <Input
                    type="text"
                    name="employeeName"
                    value={formik.values.employeeName}
                    onChange={formik.handleChange}
                  />
                </Col>
                <Col md={2}>
                  <Label>From Month <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromMonth"
                    value={formik.values.fromMonth}
                    onChange={(val) => formik.setFieldValue("fromMonth", val)}
                    onBlur={() => formik.setFieldTouched("fromMonth", true)}
                  />
                  {formik.touched.fromMonth && formik.errors.fromMonth && (
                    <div className="text-danger mt-1">{formik.errors.fromMonth}</div>
                  )}
                </Col>
                <Col md={2}>
                  <Label>To Month <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toMonth"
                    value={formik.values.toMonth}
                    onChange={(val) => formik.setFieldValue("toMonth", val)}
                    onBlur={() => formik.setFieldTouched("toMonth", true)}
                  />
                  {formik.touched.toMonth && formik.errors.toMonth && (
                    <div className="text-danger mt-1">{formik.errors.toMonth}</div>
                  )}
                </Col>
                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-export me-2">
                    <i className="fas fa-file-export me-1" /> Export
                  </Button>
                  <Button type="reset" onClick={formik.handleReset} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainerColumnTotal
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayrollReportMonthlyProfTax;
